/* Muse&Paw: Stories from customers' walls. Behaviour for sections/mp-stories.liquid.
Cards open on hover (mouse), on tap (touch) and on keyboard focus. Reels play muted while
on screen and open full size when clicked. The Delivered email links to the Reviews page with
?review=1&rating=&piece=&order=; those fill the form and are then removed from the address bar. */
(function () {
if (window.__mpStories) return;
window.__mpStories = true;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var WORDS = ['', 'Not for me', 'Could be better', "It's fine", 'Really good', 'Love it'];
function init(wrap) {
var section = wrap.querySelector('.mp-stories');
var dialog = wrap.querySelector('[data-mp-dialog]');
var track = wrap.querySelector('[data-mp-track]');
var openCard = null;
var lastPointer = 'mouse';
if (!section) return;
function setOpen(card, on) {
if (!card) return;
if (on) {
if (openCard && openCard !== card) openCard.classList.remove('is-open');
card.classList.add('is-open');
openCard = card;
} else {
card.classList.remove('is-open');
if (openCard === card) openCard = null;
}
}
/* cards */
section.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
section.addEventListener('pointerover', function (e) {
if (e.pointerType !== 'mouse') return;
var card = e.target.closest('[data-mp-card]');
if (!card || (track && track.classList.contains('is-dragging'))) return;
setOpen(card, true);
});
section.addEventListener('pointerout', function (e) {
if (e.pointerType !== 'mouse') return;
var card = e.target.closest('[data-mp-card]');
if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
setOpen(card, false);
});
section.addEventListener('click', function (e) {
if (e.target.closest('[data-mp-open-form]')) { openForm({}); return; }
var arrow = e.target.closest('[data-mp-dir]');
if (arrow && track) {
track.scrollBy({ left: Number(arrow.getAttribute('data-mp-dir')) * track.clientWidth * 0.62, behavior: reduce ? 'auto' : 'smooth' });
return;
}
if (track && track.getAttribute('data-mp-dragged')) return;
var card = e.target.closest('[data-mp-card]');
var reel = e.target.closest('[data-mp-reel]');
if (lastPointer === 'mouse') { if (reel) openReel(reel); return; }
if (card) {
if (card.classList.contains('is-open')) { if (reel) openReel(reel); else setOpen(card, false); }
else setOpen(card, true);
return;
}
if (reel) openReel(reel);
});
section.addEventListener('focusin', function (e) {
var card = e.target.closest('[data-mp-card]');
if (card && card.matches(':focus-visible')) setOpen(card, true);
});
section.addEventListener('focusout', function (e) {
var card = e.target.closest('[data-mp-card]');
if (card && !card.contains(e.relatedTarget)) setOpen(card, false);
});
section.addEventListener('keydown', function (e) {
var card = e.target.closest('[data-mp-card], [data-mp-reel]');
if (!card) return;
if (e.key === 'Enter' || e.key === ' ') {
e.preventDefault();
if (card.hasAttribute('data-mp-reel')) openReel(card);
else setOpen(card, !card.classList.contains('is-open'));
}
if (e.key === 'Escape') setOpen(card, false);
});
/* drag the wall sideways with a mouse */
if (track && track.classList.contains('mp-track')) {
var down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, v = 0, raf = 0;
track.addEventListener('pointerdown', function (e) {
if (e.pointerType !== 'mouse' || e.button !== 0) return;
down = true; moved = false; startX = lastX = e.clientX; startLeft = track.scrollLeft; lastT = performance.now(); v = 0;
cancelAnimationFrame(raf);
});
window.addEventListener('pointermove', function (e) {
if (!down) return;
var dx = e.clientX - startX;
if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); setOpen(openCard, false); }
if (!moved) return;
track.scrollLeft = startLeft - dx;
var t = performance.now();
v = (e.clientX - lastX) / Math.max(1, t - lastT);
lastX = e.clientX; lastT = t;
});
window.addEventListener('pointerup', function () {
if (!down) return;
down = false;
if (!moved) return;
track.classList.remove('is-dragging');
track.setAttribute('data-mp-dragged', '1');
setTimeout(function () { track.removeAttribute('data-mp-dragged'); }, 80);
if (reduce) return;
var vel = -v * 16;
(function glide() {
track.scrollLeft += vel;
vel *= 0.93;
if (Math.abs(vel) > 0.5) raf = requestAnimationFrame(glide);
})();
});
}
/* reels play muted while on screen */
var videos = section.querySelectorAll('.mp-media video');
if (videos.length && 'IntersectionObserver' in window) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
var vid = en.target;
if (en.isIntersecting && !reduce) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
else vid.pause();
});
}, { threshold: 0.35 });
videos.forEach(function (vid) {
vid.muted = true;
io.observe(vid);
var holder = vid.closest('.mp-card');
vid.addEventListener('timeupdate', function () {
if (vid.duration) holder.style.setProperty('--mp-p', (vid.currentTime / vid.duration * 100).toFixed(1) + '%');
});
});
}
function openReel(card) {
var source = card.querySelector('video');
if (!source) return;
var pair = card.closest('.mp-pair');
var reviewIn = pair ? pair.querySelector('.mp-solo .mp-in') : card.querySelector('.mp-review .mp-in');
var box = wrap.querySelector('.mp-reelbox');
if (!box) {
box = document.createElement('dialog');
box.className = 'mp-reelbox';
box.setAttribute('aria-label', 'Customer video');
box.innerHTML = '<div class="mp-rb"><video playsinline controls loop></video><div class="mp-rb-side"><div class="mp-rb-review"></div><button type="button" class="mp-btn mp-btn--light" data-mp-close>Close</button></div></div>';
wrap.appendChild(box);
box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('[data-mp-close]')) box.close(); });
box.addEventListener('close', function () { box.querySelector('video').pause(); });
}
box.style.setProperty('--mp-tint', getComputedStyle(pair || card).getPropertyValue('--mp-tint'));
var vid = box.querySelector('video');
vid.innerHTML = source.innerHTML;
vid.poster = source.getAttribute('poster') || '';
vid.load();
box.querySelector('.mp-rb-review').innerHTML = reviewIn ? '<div class="mp-in">' + reviewIn.innerHTML + '</div>' : '';
if (typeof box.showModal === 'function') box.showModal(); else box.setAttribute('open', '');
var p = vid.play(); if (p && p.catch) p.catch(function () {});
}
/* the write-a-review form */
function paint(n) {
if (!dialog) return;
dialog.querySelectorAll('.mp-rate-stars label').forEach(function (l, i) { l.classList.toggle('is-lit', i < n); });
var word = dialog.querySelector('[data-mp-rate-word]');
if (word) word.textContent = n ? WORDS[n] : 'Choose 1 to 5 stars';
}
function checked() {
var c = dialog && dialog.querySelector('[data-mp-n]:checked');
return c ? Number(c.getAttribute('data-mp-n')) : 0;
}
function openForm(opts) {
if (!dialog) return;
if (opts.rating) {
var star = dialog.querySelector('[data-mp-n="' + opts.rating + '"]');
if (star) star.checked = true;
}
if (opts.piece) {
var sel = dialog.querySelector('[data-mp-piece]');
if (sel) Array.prototype.forEach.call(sel.options, function (o) { if (o.getAttribute('data-handle') === opts.piece) sel.value = o.value; });
}
if (opts.order) {
var order = dialog.querySelector('[data-mp-order]');
var source = dialog.querySelector('[data-mp-source]');
if (order) order.value = '#' + String(opts.order).replace(/[^0-9A-Za-z-]/g, '');
if (source) source.value = 'Delivered email link';
}
paint(checked());
if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
else dialog.setAttribute('open', '');
}
if (dialog) {
var form = dialog.querySelector('form');
if (form) form.noValidate = true;
dialog.addEventListener('click', function (e) {
if (e.target === dialog || e.target.closest('[data-mp-close]')) dialog.close();
});
dialog.querySelectorAll('[data-mp-n]').forEach(function (input) {
input.addEventListener('change', function () { paint(checked()); });
});
dialog.querySelectorAll('.mp-rate-stars label').forEach(function (label, i) {
label.addEventListener('pointerenter', function () { paint(i + 1); });
label.addEventListener('pointerleave', function () { paint(checked()); });
});
if (form) {
form.addEventListener('submit', function (e) {
if (!form.querySelector('[data-mp-n]')) return;
var missing = [];
if (!checked()) missing.push('choose a star rating');
var text = form.querySelector('textarea');
if (text && !text.value.trim()) missing.push('write a few words');
var name = form.querySelector('[name="contact[First name]"]');
if (name && !name.value.trim()) missing.push('add your first name');
var consent = form.querySelector('[name="contact[Consent]"]');
if (consent && !consent.checked) missing.push('tick the box so we can publish it');
var err = form.querySelector('[data-mp-err]');
if (missing.length) {
e.preventDefault();
if (err) { err.textContent = 'To send it, ' + missing.join(', ') + '.'; err.hidden = false; }
}
});
}
var params = new URLSearchParams(window.location.search);
var fromLink = params.has('review') || params.has('rating') || params.has('order');
if (dialog.querySelector('[data-mp-posted]') || dialog.querySelector('[data-mp-server-err]')) {
openForm({});
} else if (fromLink) {
openForm({ rating: params.get('rating'), piece: params.get('piece'), order: params.get('order') });
['review', 'rating', 'piece', 'order'].forEach(function (k) { params.delete(k); });
var rest = params.toString();
window.history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
}
}
}
function start() {
document.querySelectorAll('[data-mp-stories]').forEach(init);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
})();
